import { Component, OnInit } from '@angular/core';
import { Blog, Pagination } from '../../../../models';
import constants from '../../../../utility/constants';
import { PublicBlogService } from '../../../../services/public-blog.service';
import routeTable from '../../../../utility/routeTable';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.css']
})
export class BlogListComponent implements OnInit {
  blogData: Array<Blog> = [];
  searchTerm: string = '';
  pageNumber = 1;
  pageSize = constants.public.blogPageSize;
  sortBy = '';
  sortOrder = '';
  isPaginated = true;
  totalBlog: number;
  onlyActive = false;
  routes: any;
  private subscriptions: Array<Subscription> = [];

  constructor(private publicBlogService: PublicBlogService) {
    this.routes = routeTable.public;
  }

  ngOnInit(): void {
    this.getAllBlog();
  }
  getAllBlog() {

    let model: Pagination = {
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
    };

    const blogs = this.publicBlogService.getBlogs(model).subscribe((response) => {
      this.blogData = response.data;
      this.totalBlog = response.totalCount;
    });
    this.subscriptions.push(blogs)
  }

  onPageChange(paging: number) {
    this.pageNumber = paging;
    this.getAllBlog();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
